import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { IMPACT_STATS } from '../../service/impactStats';
import CountUpNumber from './CountUpNumber';

// "KBT by the Numbers" — real, published figures from the client's Annual
// Impact report (Aug 2026), placed right before the tier grid so a
// visitor sees what membership actually funds in concrete terms before
// being asked to commit to one. Deliberately just the numbers: the source
// infographic's program list and "why it matters" panel belong to that
// leaflet, not duplicated here on the signup page.
export default function ImpactStatsSection() {
  return (
    <Box
      component="ul"
      sx={{
        listStyle: 'none',
        m: 0,
        p: 0,
        display: 'grid',
        // Fixed column counts, not auto-fit — 12 stats need to land as a
        // clean 6x2 grid on desktop, which a width-driven auto-fit can't
        // guarantee (it wraps wherever the container width happens to
        // divide evenly, not at a specific count).
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', md: 'repeat(6, 1fr)' },
        gap: { xs: 3, sm: 4 },
        maxWidth: 1080,
        mx: 'auto',
      }}
    >
      {IMPACT_STATS.map((stat, i) => (
        <motion.li
          key={stat.label}
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6, delay: (i % 6) * 0.06, ease: [0.22, 1, 0.36, 1] }}
          style={{ textAlign: 'center' }}
        >
          <Box
            sx={{
              fontFamily: 'var(--font-display)',
              fontWeight: 700,
              fontSize: { xs: 32, md: 40 },
              lineHeight: 1,
              color: 'var(--navy-500)',
            }}
          >
            <CountUpNumber value={stat.value} suffix={stat.suffix} prefix={stat.prefix} />
          </Box>
          <Box
            sx={{
              mt: 1,
              fontFamily: 'var(--font-body)',
              fontSize: 13.5,
              lineHeight: 1.4,
              color: 'var(--navy-300)',
            }}
          >
            {stat.label}
          </Box>
        </motion.li>
      ))}
    </Box>
  );
}
